import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'employees.documents.name';
    property = 'name';
    sortField = 'name';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
